exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-card {\n  align-items: center;\n  background-color: pink;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  display: inline-block;\n  font-size: 12px;\n  height: 50px;\n  justify-content: center;\n  width: 150px;\n  margin-right: 5px;\n  transition: all 200ms;\n}\n.comparison-card {\n  align-items: center;\n  background-color: #fff;\n  border-radius: 20px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  display: inline-block;\n  font-size: 22px;\n  height: 100px;\n  justify-content: center;\n  width: 150px;\n  transition: all 200ms;\n}\r\n", ""]);

// exports
